module.exports = __webpack_public_path__ + "img/grid-3x2.44cabe74.svg";